module.exports = __webpack_public_path__ + "img/dsci0149.1f81b2f0.jpg";